var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-multiline is-mobile is-variable is-5"},_vm._l((_vm.teamMembers),function(teamMember,idx){return _c('div',{key:`member-${idx}`,staticClass:"column is-6-mobile is-3-tablet is-3-desktop"},[_c('ob-team-member',{key:teamMember.name,attrs:{"team-member":teamMember}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }